import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";
import { FabricImage } from "@/components/FabricImage";
import { Pencil, Trash2 } from "lucide-react";

export const FabricCard = ({ item, selected, onToggle, onEdit, onDelete, onPreview }) => (
  <div
    data-testid={`fabric-card-${item.id}`}
    className={`hard-hover group relative border bg-white ${selected ? "border-zinc-950 shadow-[4px_4px_0px_0px_rgba(9,9,11,1)]" : "border-zinc-200"}`}
  >
    <div className="relative">
      <FabricImage path={item.image_path} alt={`${item.quality_name} shade ${item.shade_number}`} className="h-40 w-full cursor-zoom-in object-cover" onClick={() => onPreview?.(item)} data-testid={`fabric-preview-${item.id}`} />
      <div className="absolute left-2 top-2">
        <Checkbox
          data-testid={`fabric-select-${item.id}`}
          checked={selected}
          onCheckedChange={() => onToggle(item.id)}
          className="h-5 w-5 rounded-sm border-zinc-400 bg-white/90 data-[state=checked]:bg-zinc-950"
        />
      </div>
      <div className="absolute right-2 top-2 flex gap-1 opacity-0 transition-opacity duration-200 group-hover:opacity-100">        <Button
          data-testid={`fabric-edit-${item.id}`}
          size="icon"
          variant="secondary"
          className="h-7 w-7 rounded-sm bg-white/95"
          onClick={() => onEdit(item)}
        >
          <Pencil size={13} />
        </Button>
        <Button
          data-testid={`fabric-delete-${item.id}`}
          size="icon"
          variant="secondary"
          className="h-7 w-7 rounded-sm bg-white/95 text-red-600 hover:text-red-700"
          onClick={() => onDelete(item)}
        >
          <Trash2 size={13} />
        </Button>
      </div>
    </div>

    <div className="border-t border-zinc-200 p-3">
      <p className="font-head truncate text-sm font-bold tracking-tight">
        Shade {item.shade_number || "-"}
      </p>
      <p className="mt-0.5 truncate text-xs font-medium uppercase tracking-[0.15em] text-zinc-500">
        {item.colour || item.quality_name}
        {item.centre ? <span className="text-zinc-400"> · {item.centre}</span> : null}
      </p>
      <div className="mt-3 grid grid-cols-2 gap-2 border-t border-dashed border-zinc-200 pt-2">
        <div>
          <p className="text-[10px] font-bold uppercase tracking-[0.15em] text-zinc-400">Than</p>
          <p
            className={`font-mono-num text-sm font-semibold ${
              Number(item.than_stock) < 0
                ? "text-red-600"
                : Number(item.min_stock) > 0 && Number(item.than_stock) < Number(item.min_stock)
                ? "text-amber-600"
                : ""
            }`}
          >
            {item.than_stock ?? 0}
          </p>
        </div>
        <div>
          <p className="text-[10px] font-bold uppercase tracking-[0.15em] text-zinc-400">Meter</p>
          <p className={`font-mono-num text-sm font-semibold ${Number(item.meter_stock) < 0 ? "text-red-600" : ""}`}>
            {item.meter_stock ?? 0}
          </p>
        </div>
      </div>
      {(item.wsr || item.company_name) && (
        <p className="mt-2 truncate text-xs text-zinc-500">
          {item.wsr ? `WSR ₹${item.wsr}` : ""}
          {item.wsr && item.company_name ? " · " : ""}
          {item.company_name || ""}
        </p>
      )}
    </div>
  </div>
);
